var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"avator-container"},[(_vm.src!=null)?_c('Avatar',{attrs:{"src":_vm.src}}):_c('Avatar',[_vm._v(_vm._s(_vm.text))]),_c('Badge',{attrs:{"status":_vm.status}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }